"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("./utils");
const AuthContext_1 = require("./AuthContext");
const IsAllowed = ({ permissions, ...props }) => {
    const { user } = (0, AuthContext_1.useAuth)();
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, utils_1.isAllowed)(user, permissions) ? props.children : null));
};
exports.default = IsAllowed;
